import { inventorySlotQueryKeys as e } from "./useInventorySlotQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { inventorySlotsApi as r } from "@maat/api-main";
//#region src/inventorySlots/useCreateSlotMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ kind: e, inventoryId: t, data: n }) => r.createSlot(e, t, n),
		onSuccess: (t, { kind: n, inventoryId: r }) => {
			i.invalidateQueries({ queryKey: e.host(n, r) });
		}
	});
};
//#endregion
export { i as useCreateSlotMutation };
